import { Component } from 'react';
import { connect } from 'react-redux';
import { SHOW_UPLOAD_DOCUMENTS_MODAL } from '../../../modals/uploadDocumentsModal/UploadDocumentsModal.actions';
import UploadButton from '../../../ui/uploadButton/UploadButton';
import { Document } from '../Document/Document';
import styles from './DocumentsByType.module.css';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import messages from '../UploadedDocuments.messages';

const mapStateToProps = ({ tradingData }) => tradingData;
const mapDispatchToProps = (dispatch) => ({
    uploadDocByType: (documentType) =>
        dispatch({ type: SHOW_UPLOAD_DOCUMENTS_MODAL, documentType })
});
class DocumentsByType extends Component {
    getDocument() {
        const { documentTypes, documentType } = this.props;

        return _.find(documentTypes, ['value', documentType]);
    }

    handleUploadDocument = () => {
        const document = this.getDocument();

        this.props.uploadDocByType(document);
    };

    renderDocuments() {
        const { documents } = this.props;

        return _.map(documents, (document, key) => (
            <Document key={key} document={document} />
        ));
    }

    render() {
        const { documentIcon } = this.props;
        const documents = this.renderDocuments();
        const document = this.getDocument();

        return (
            <div className={styles.DocumentsByType}>
                <div className={styles.typeHeading}>
                    <span className={styles.icon}>{documentIcon}</span>
                    <span className={styles.type} data-testid="document-type">
                        {document && (
                            <FormattedMessage {...messages[document.label]} />
                        )}
                    </span>
                    <UploadButton
                        className={styles.uploadButton}
                        onClick={this.handleUploadDocument}
                    />
                </div>
                <div
                    className={styles.documentHeading}
                    data-testid="document-heading"
                >
                    <div>
                        <FormattedMessage {...messages.documentName} />
                    </div>
                    <div>
                        <FormattedMessage {...messages.documentUploadDate} />
                    </div>
                </div>
                {documents}
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(DocumentsByType);
